import { render } from "./ProfileEditNavigationCard.vue?vue&type=template&id=fecd3550&scoped=true"
import script from "./ProfileEditNavigationCard.vue?vue&type=script&lang=js"
export * from "./ProfileEditNavigationCard.vue?vue&type=script&lang=js"

import "./ProfileEditNavigationCard.vue?vue&type=style&index=0&id=fecd3550&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fecd3550"]])

export default __exports__